export const illustrationColors = {
  body: '#f3ce47',
  dark: '#b9902f',
  trim: '#3a3a3a',
  tyre: '#27211e',
  hub: '#666',
  logo: '#c12a22',
  blur: '#4f4742',
}

export const seasonColors = {
  red: '#d40511',
  // reason: we color our svgs
  // eslint-disable-next-line @dhl/mui/no-hardcoded-colors
  white: '#ffffff',
  paper: '#f6f1e7',
  paperEdge: '#ddd3c2',
  snow: '#f3f7fa',
  snowEdge: '#b8c5ce',
  pine: '#2f7d4b',
  pineShade: '#22603a',
  wood: '#7a4b2a',
  jute: '#b98c55',
  juteShade: '#94693a',
  rope: '#6e5032',
  orange: '#d9822b',
  rust: '#b5562f',
  ochre: '#d8a63c',
  coolBox: '#3f8fc9',
  leaf: '#4f8f3f',
  planter: '#4b7a3a',
  planterRim: '#3b6530',
  pink: '#f29bb6',
  blossom: '#f5b8ca',
  purple: '#8e5bb5',
}
